export default {

    historic: {data: []},
    historicSale: {data: []},
}